import React, { useState, useEffect } from 'react';
import { FormControl, Button, ButtonGroup } from 'react-bootstrap';
import { XSquare } from 'react-bootstrap-icons';
import { debounce } from 'lodash';

function FiltrosProductos({ onFilterChange }) {
  const [filtroReferencia, setFiltroReferencia] = useState('');
  const [filtroNombre, setFiltroNombre] = useState('');
  const [filtroStock, setFiltroStock] = useState('');
  const [filtroPrecioCompra, setFiltroPrecioCompra] = useState('');
  const [filtroPrecioVenta, setFiltroPrecioVenta] = useState('');
  const [isActive, setIsActive] = useState(false);

  const debouncedFilterChange = debounce((filters) => {
    if (isActive) {
      onFilterChange(filters);
    }
  }, 300);

  useEffect(() => {
    const filters = {
      referencia: filtroReferencia,
      nombre: filtroNombre,
      stock: filtroStock,
      precioCompra: filtroPrecioCompra,
      precioVenta: filtroPrecioVenta,
    };

    debouncedFilterChange(filters);
  }, [filtroReferencia, filtroNombre, filtroStock, filtroPrecioCompra, filtroPrecioVenta, isActive]);

  const handleLimpiarClick = () => {
    setFiltroReferencia('');
    setFiltroNombre('');
    setFiltroStock('');
    setFiltroPrecioCompra('');
    setFiltroPrecioVenta('');
    onFilterChange({}); // Llama a onFilterChange con un objeto vacío para limpiar los filtros
  };

  const handleFocus = () => {
    setIsActive(true);
  };

  const handleBlur = () => {
    setIsActive(false);
  };

  return (
    <div className='d-flex align-items-center m-3'>
      <FormControl
        placeholder='Filtra por Referencia'
        className='me-2'
        value={filtroReferencia}
        onChange={(e) => setFiltroReferencia(e.target.value)}
        onFocus={handleFocus}
        onBlur={handleBlur}
      />
      <FormControl
        placeholder='Filtra por Nombre'
        className='me-2'
        value={filtroNombre}
        onChange={(e) => setFiltroNombre(e.target.value)}
        onFocus={handleFocus}
        onBlur={handleBlur}
      />
      <FormControl
        placeholder='Filtra por Stock'
        className='me-2'
        value={filtroStock}
        onChange={(e) => setFiltroStock(e.target.value)}
        onFocus={handleFocus}
        onBlur={handleBlur}
      />
      <FormControl
        placeholder='Filtra por Precio de Compra'
        className='me-2'
        value={filtroPrecioCompra}
        onChange={(e) => setFiltroPrecioCompra(e.target.value)}
        onFocus={handleFocus}
        onBlur={handleBlur}
      />
      <FormControl
        placeholder='Filtra por Precio de Venta'
        className='me-2'
        value={filtroPrecioVenta}
        onChange={(e) => setFiltroPrecioVenta(e.target.value)}
        onFocus={handleFocus}
        onBlur={handleBlur}
      />
      <ButtonGroup>
        <Button variant='dark' title='Limpiar' onClick={handleLimpiarClick}>
          <XSquare />
        </Button>
      </ButtonGroup>
    </div>
  );
}

export default FiltrosProductos;
